import React from 'react';
import cn from 'classnames';
import SlotHeader from './SlotHeader/index';
import SlotContent from './SlotContent/index';
import style from './cubbySlot.module.scss';
import { ReactComponent as AddSlot } from '@assets/images/Fireboard/addSlot.svg';
import SlotFooter from './SlotFooter/index';
import constant from '@components/common/globalization';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const CubbySlot = props => {
  const {
    slot,
    onSlotAssign,
    handleShowCheckDetails,
    pickedUp,
    handleExpandedRightSection,
    overlay,
    setOverlay,
    actionRef,
    iconRef,
    rowCount,
    columnCount,
    setSelectedCheck,
    clearSlot,
    setPopup,
  } = props;

  const checkData = slot?.checkData || {};
  const isOccupied =
    checkData &&
    Object.keys(checkData).length !== 0 &&
    checkData.constructor === Object;

  const overlayOptions = [
    { key: 'clear', name: FLABEL().CHECK_CLEAR, onClick: () => clearSlot(slot) },
    {
      key: 'move',
      name: FLABEL().CHECK_MOVE,
      onClick: () => {
        setPopup({ type: constant.MOVE_SLOT });
        setSelectedCheck(checkData.id);
      },
    },
    {
      key: 'expandedview',
      name: FLABEL().CHECK_MORE_DETAILS,
      onClick: () => handleShowCheckDetails(checkData),
    },
  ];

  const overlayBigHeight = rowCount < 5 && columnCount < 5;
  const HeightFor5 = rowCount === 5;

  return (
    <div className={cn('text-left', style.slotContainer)}>
      <SlotHeader
        isOccupied={isOccupied}
        slot={slot}
        overlay={overlay}
        setOverlay={setOverlay}
        iconRef={iconRef}
      />
      {isOccupied ? (
        <>
          <SlotContent
            check={checkData}
            showCheckNumber={true}
            isAssignSlot={true}
            slot={slot}
          />
          <SlotFooter
            check={checkData}
            handleExpandedRightSection={handleExpandedRightSection}
            setSelectedCheck={setSelectedCheck}
            pickedUp={pickedUp}
          />
        </>
      ) : (
        <UnOccupiedSlotContent slot={slot} onSlotAssign={onSlotAssign} />
      )}
      {overlay && overlay.slotId === slot?.id && (
        <>
          <div
            className={cn(
              style.overlay,
              overlayBigHeight && style.overlay2,
              HeightFor5 && style.overlay5
            )}
          >
            <div
              className={cn(
                style.overlayTip,
                overlayBigHeight && style.overlayTip2,
                HeightFor5 && style.overlayTip5
              )}
            ></div>
            <div
              ref={actionRef}
              className={cn(
                style.overlayContent,
                'row mx-0 p-0 flex-column',
                overlayBigHeight && style.overlayContent2
              )}
            >
              {overlayOptions.map(item => {
                return (
                  <div
                    key={item.key}
                    className={cn(
                      style.moreActions,
                      overlayBigHeight && style.moreActions2,
                      HeightFor5 && style.moreActions5
                    )}
                    onClick={item?.onClick}
                  >
                    {item.name}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CubbySlot;

const UnOccupiedSlotContent = ({ slot, onSlotAssign }) => {
  return (
    <div
      className={cn(style.unOccupiedWrapper)}
      onClick={() => onSlotAssign(slot)}
    >
      <span className={cn(style.plus)}>{<AddSlot />}</span>
    </div>
  );
};
